// EDITABLE BUSINESS CONFIG — contact details and booking availability can be updated here.
export const SITE = {
  companyName: "Hind Pest Control",
  tagline: "Professional Pest Management",
  phoneDisplay: "9891893539",
  phoneHref: "tel:+919891893539",
  whatsappDisplay: "9891893539",
  whatsappHref:
    "https://wa.me/919891893539?text=Hi%20Hind%20Pest%20Control%2C%20I%20would%20like%20to%20book%20a%20free%20pest%20inspection.",
  secondaryPhoneDisplay: "7838617362",
  secondaryPhoneHref: "tel:+917838617362",
  email: "care@hindpestcontrol.in", // PLACEHOLDER — confirm business email
  address: "Delhi NCR, India", // PLACEHOLDER — exact address to be supplied
  hours: "Mon–Sun · 8:00 AM – 8:00 PM", // PLACEHOLDER
  yearsExperience: "25+",
  primaryAreas: ["Delhi", "Gurugram", "Noida"],
  extraAreas: ["Ghaziabad", "Faridabad", "Greater Noida", "Dwarka"], // editable until confirmed
  // Booking availability: all days open by default. Edit slots or daysAhead to change availability.
  booking: {
    daysAhead: 14,
    slots: ["08:00 AM", "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM", "06:00 PM", "07:00 PM"],
  },
};

export const PEST_OPTIONS = [
  "Cockroaches",
  "Termites",
  "Bed Bugs",
  "Rodents / Rats",
  "Mosquitoes",
  "Ants",
  "Flies",
  "Multiple / Not Sure",
  "Commercial Property",
];
